import React from 'react';
import { useCutoutImage } from '../hooks/useCutoutImage';
type BookCoverProps = {
  src: string;
  alt: string;
  className?: string;
};

/**
 * Book cover thumbnail on a black frame.
 * Studio mockups (PNG) ship with a flat white backdrop, so it is keyed out at
 * runtime and only the book itself shows over black. Photographic mockups
 * (WEBP, shot in a room) keep their scene and simply fill the frame.
 */
export function BookCover({
  src,
  alt,
  className = ''
}: BookCoverProps) {
  const isPhotoMockup = src.toLowerCase().endsWith('.webp');
  const resolvedSrc = useCutoutImage(src, !isPhotoMockup);
  return <span className={`block shrink-0 overflow-hidden rounded-lg bg-black ${className}`} data-id="element-39" data-mp="2egwv11qriyjh">
      <img src={resolvedSrc} alt={alt} className={`h-full w-full ${isPhotoMockup ? 'object-cover object-center' : 'object-contain'}`} loading="lazy" data-id="element-40" data-mp="29hjwhjqj4312" />
    </span>;
}